import type { EventStatusEnum } from '@/gql/scalars';

const obj: { [key in EventStatusEnum]: string } = {
  completed: 'Final',
  in_progress: 'In Progress',
  postponed: 'Postponed',
  cancelled: 'Cancelled',
};

export default obj;
